<template lang="pug">
.container.center-box
  VeeForm(ref="form")
    form.center-box-inner
      .page-title
      h4 補助案件名稱: {{ $route.query.activity_name }}
      Vee(rules="required" v-slot="{errors}")
        .mb-3
          .input-group
            .input-group-prepend
              label.input-group-text.justify-content-end.required 公文字號
              .input-group-text 臺教師 (一) 字第
            input.form-control(v-model="data.missive_code" type="text", placeholder="請輸入公文字號")
            .input-group-append
              .input-group-text 號
          .input-err-msg {{errors[0]}}
      Vee(rules="required|max:200" v-slot="{errors}")
        .mb-3
          .input-group
            .input-group-prepend
              label.input-group-text.width-s.justify-content-end.required 活動名稱 {{ this.$route.query.id }}
            input.form-control(v-model="data.activity_name" type="text" value="this.$route.query.activity_name")
            .input-group-append
              .input-group-text.text-primary 限200字
          .input-err-msg {{errors[0]}}
      .mb-3
        .input-group
          .input-group-prepend
            label.input-group-text.width-s.justify-content-end.required 活動時間
          Vee(rules="required" ref="dateStart").form-control
            label(for="start").pr-2 開始日:
            input.date-input(v-model="data.activity_starttime" type="date", min="2022-01-01", max="2030-12-31")
          Vee(rules="required" ref="dateEnd").form-control
            label(for="start").pr-2 結束日:
            input.date-input(v-model="data.activity_endtime" type="date", min="2022-01-01", max="2030-12-31")
        p.text-danger.mt-2 請填辦理期間起訖日期，計畫期程如有變更請備文到教育部
        .input-err-msg {{dateError}}
      Vee(rules="required|max:200" v-slot="{errors}")
        .mb-3
          .input-group
            .input-group-prepend
              label.input-group-text.width-s.justify-content-end.required 活動地點
            input.form-control(v-model="data.activity_location" type="text")
            .input-group-append
              .input-group-text.text-primary 限200字
          .input-err-msg {{errors[0]}}
      Vee(rules="required" v-slot="{errors}")
        .mb-3
          .input-group
            .input-group-prepend
              label.input-group-text.width-s.justify-content-end.required 活動參與次數
            input.form-control(v-model="data.activity_counter" type="text")
          .input-err-msg {{errors[0]}}
      Vee(rules="required" v-slot="{errors}")
        .mb-3
          .input-group
            .input-group-prepend
              label.input-group-text.width-s.justify-content-end.required 執行說明
            textarea.form-control(v-model="data.result_memo" style="height:250px")
          .input-err-msg {{errors[0]}}



      label.justify-content-end.required 上傳代表圖
        FileUploader(
          :files.sync="files"
          :removeFileIds.sync="removeFileIds"
          title="請上傳至少一張代表圖"
        )


      //- .input-group.mb-3
      //-   label(for="") 影音檔
      //-   .input-group.mb-3(v-for="v in videos")
      //-     .input-group-prepend
      //-       .input-group-text.justify-content-end(style="background-color:#eee;width:90px") 影音網址
      //-     input.form-control(v-model="v.url" type="text")
      //-   p(style="color:var(--blue);margin-top:-10px;margin-bottom:-5px;")
      //-     | 僅限 YouTube 或 Google Drive 影音網址。
      //-     br
      //-     | 範例:https://www.youtube.com/watch?v=thtskt3vIHgS

    button.btn.btn-primary.btn-lg(type="button" @click="submit")
      span.text-light 確認後上傳

</template>

<script>
import { fetchGrantApplicationDetail, uploadGrantApplicationResult } from '@/api/client/Grant'
import FileUploader from './FileUploader'
import { extend } from 'vee-validate'
import { BIconEye, BIconEyeFill } from 'bootstrap-vue'

export default {
  components: { FileUploader },
  data () {
    return {
      isMounted: false,
      files: [],
      removeFileIds: [],
      videos: [
        { id: null, url: null },
        { id: null, url: null },
      ],
      data: {
        u_str: null,
        application_id: null,
        missive_code: null,
        activity_name: null,
        activity_starttime: null,
        activity_endtime: null,
        activity_location: null,
        activity_counter: null,
        result_memo: null
      }
    }
  },
  computed: {
    dateError () {
      if (!this.isMounted) return ''
      if (this.$refs.dateStart.errors.length) return this.$refs.dateStart.errors[0]
      if (this.$refs.dateEnd.errors.length) return this.$refs.dateEnd.errors[0]
      return ''
    }
  },
  methods: {
    setFiles (value) {
      this.files = value
    },
    setDelFileIds (value) {
      this.removeFileIds = value
    },
    onUpload (file, index, event) {
      const { files } = event.target
      this.data.attach_files[index].file = files[0]
    },
    toggleRemoveFile (file, index) {
      const { id } = file
      if (!id) {
        this.data.attach_files.splice(index, 1)
        return
      }
      if (this.removeFileIds.includes(id)) {
        this.removeFileIds = this.removeFileIds.filter(e => e !== id)
        return
      }
      this.removeFileIds.push(id)
      this.removeFileIds = [...new Set(this.removeFileIds)]

    },
    downloadFile (file) {
      if (!file.src) {
        return
      }
      const link = document.createElement('a')
      link.href = file.src
      link.target = '_blank'
      link.click()
    },
    addEmptyFile () {
      this.data.attach_files.push({ file: null, src: null })
    },
    async fetchData ({ u_str, applicationId }) {
      const { data } = await fetchGrantApplicationDetail({ u_str, applicationId })
      const { grant_name, activity_starttime, activity_endtime } = data
      this.data = {
        ...this.data,
        grant_name,
        activity_starttime,
        activity_endtime
      }
    },
    async submit () {
      function handelResStringParse (res) {
        if (typeof res === 'string') {
          res = JSON.parse(`[${res.replaceAll('}{', '},{')}]`)
          throw new Error(res[0].errmsg)
        }
        return res
      }
      try {
        const { form } = this.$refs
        const success = await form.validate()
        // if (!success) {
        //   const target = form.$children.find( ref => ref.errors && ref.errors.length > 0)
        //   const input = target.$el.querySelector('input')
        //   const el = input || select
        //   console.log(target)
        //   if(el) el.focus()
        //   // input.focus()
        //   return
        // }
        const payload = { ...this.data }
        const addFiles = this.files.filter(e => e.file).map(e => e.file)
        const addFileMemos = addFiles.map(f => f.name)
        const deleteFileIds = this.removeFileIds
        const addVideos = this.videos
        const res = await uploadGrantApplicationResult({ payload, addFiles, addFileMemos, deleteFileIds, addVideos })


      const { errcode, errmsg } = handelResStringParse(res)
      if (errcode !== 0) throw new Error(errmsg || '發生錯誤')
        //this.$router.push({ name: 'loginToMaintain' })
        //this.$router.push({ path: '/artedu1872/subsidy/loginToMaintain' })
         this.$router.push({ path: '/artedu1872/subsidy/applicationResult' })
      } catch (err) {
        console.warn(err)
        alert(err.message)
      }
    }
  },
  async mounted () {
    try {
      this.isMounted = true
      const user = sessionStorage.getItem('user')
      if (!user) throw new Error('no user')
      const { u_str } = JSON.parse(user)
      const { id: applicationId } = this.$route.query
      this.data.application_id = applicationId
      if (!u_str) return
      this.data.u_str = u_str
      await this.fetchData({ u_str, applicationId })
    } catch (err) {
      console.warn(err)
      //this.$router.push({ name: 'loginToMaintain' })
      this.$router.push({ path: '/artedu1872/subsidy/loginNow' })
    }
  }
}
</script>

<style lang="sass" scoped>
.input-err-msg
  color: red
.psw-note
  font-size: 12px
  padding: 0 1rem
  margin-top: 0
input.money-input
  max-width: 150px
input.else-input
  max-width: 200px
span.required:before, label.required:before
  content: "*"
  color: red
</style>




// WEBPACK FOOTER //
// src/views/Artedu1872/components/UploadData/Upload.vue